import { render, staticRenderFns } from "./bucatarie.vue?vue&type=template&id=191bb5c9"
import script from "./bucatarie.vue?vue&type=script&lang=js"
export * from "./bucatarie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports